import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {LongTask} from 'types/long-task';
import {request} from 'utils/request-axios';

type PossibleResponses = Api.Response.SuccessAxios<'longtask', LongTask>;

export const useDeleteAllLineItems = (): UseMutationResult<
    PossibleResponses,
    Error
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: () =>
            request({
                locale,
                method: 'POST',
                url: window.Urls.catalog_delete_all_view(),
            }),
    });
};
